"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CWAlarmState = void 0;
var CWAlarmState;
(function (CWAlarmState) {
    CWAlarmState["INSUFFICIENT_DATA"] = "INSUFFICIENT_DATA";
    CWAlarmState["OK"] = "OK";
    CWAlarmState["ALARM"] = "ALARM";
})(CWAlarmState || (exports.CWAlarmState = CWAlarmState = {}));
